import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Summer/NegativeNumbers/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'NegativeNumbers',
  field: 'Number',
  weeks: [9, 9],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/NegativeNumbers/1UnderstandNegativeNumbers" */ './1UnderstandNegativeNumbers'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/NegativeNumbers/2CountThroughZeroIn1s" */ './2CountThroughZeroIn1s'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/NegativeNumbers/3CountThroughZeroInMultiples" */ './3CountThroughZeroInMultiples'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/NegativeNumbers/4CompareAndOrderNegativeNumbers" */ './4CompareAndOrderNegativeNumbers'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/NegativeNumbers/5FindTheDifference" */ './5FindTheDifference'
        )
    })
  ]
});
export default Block;
